import ErrorWrapper from './error-wrapper';
// import { useMutation } from '@tanstack/react-query';
// import { setNewAdmin } from '../../api/administration-api';
// import { Messages } from '../../utils/message-constants';
// import { useStore } from '../../components/state/zustand-store';
import { useLocation } from 'react-router-dom';

import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import IconButton from '@mui/material/IconButton';
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import LinkOutlined from '@mui/icons-material/LinkOutlined';

export default function InvalidAdminPage() {
  const location = useLocation();
  // const navigate = useNavigate();

  type LocationState = {
    hasNoAdmin?: boolean;
    oldAdmin?: string;
    currentUserIsAdmin?: boolean;
    loggedInUserEmail?: string;
  } | null;

  const state = location.state as LocationState;
  const hasNoAdmin = state?.hasNoAdmin || false;
  const oldAdmin = state?.oldAdmin || '';
  // const currentUserIsAdmin = state?.currentUserIsAdmin || false;
  // const loggedInUserEmail = state?.loggedInUserEmail || '';

  // const { setSnackbar } = useStore();

  // const { mutate, isPending } = useMutation({
  //   mutationFn: (email: string) => setNewAdmin(email, ''),
  //   onSuccess: () => {
  //     setSnackbar({
  //       open: true,
  //       severity: 'success',
  //       message: Messages.Success.Updated('gPanel Admin'),
  //     });

  //     navigate('/');
  //   },
  //   onError: (error) => {
  //     setSnackbar({
  //       open: true,
  //       severity: 'error',
  //       message: Messages.Errors.Network.Updating('gPanel Admin'),
  //     });

  //   },
  // });

  return (
    <ErrorWrapper>
      <Card variant="outlined" sx={{ maxWidth: 920, zIndex: 2, px: 4, py: 6 }}>
        <CardHeader title={'Invalid Admin'} />
        <CardContent sx={{ pt: 0 }}>
          <Stack gap={2}>
            <Stack flexDirection="row" gap={1} alignItems="center">
              <Typography variant="body1">
                Please ensure Data Access has been granted by your domain.
              </Typography>
              <IconButton
                size="small"
                component="a"
                href="https://resources.promevo.com/knowledgebase/gpanel/getting-started/how-to-configure-gpanel"
                target="_blank"
                rel="noopener noreferrer"
              >
                <LinkOutlined />
              </IconButton>
            </Stack>
            {hasNoAdmin && (
              <Typography variant="body1">
                There is no admin set for your subscription.
              </Typography>
            )}
            {oldAdmin && !hasNoAdmin && (
              <Typography variant="body1">
                If Data Access has been granted then the current admin email we
                have on file (
                <Box component="span" fontWeight="bold">
                  {oldAdmin}
                </Box>
                ) is no longer a valid admin email.
              </Typography>
            )}
            {/* {currentUserIsAdmin && loggedInUserEmail !== '' && (
              <>
                <Typography variant="body1">
                  We have confirmed that you are an admin for your domain.
                  Please click the button below to save your email as the
                  default admin.
                </Typography>
                <Button
                  variant="contained"
                  sx={{ width: 'fit-content', mx: 'auto' }}
                  onClick={() => {
                    if (loggedInUserEmail && loggedInUserEmail !== '') {
                      mutate(loggedInUserEmail);
                    }
                  }}
                  loading={isPending}
                >
                  Save Email as Default Admin
                </Button>
              </>
            )} */}
            <Typography variant="body1">
              Please contact{' '}
              <Link href="mailto:support@promevo.com" target="_blank">
                support@promevo.com
              </Link>{' '}
              for assistance.
            </Typography>
          </Stack>
        </CardContent>
      </Card>
    </ErrorWrapper>
  );
}
